export function reverseCountry(value?: string): string | undefined {
  if (value === 'US') {
    return 'U.S.';
  }
  if (value === 'OTHER') {
    return 'Other';
  }
  return undefined;
}

export function booleanToYesNo(value?: boolean): string | undefined {
  if (value === true) {
    return 'YES';
  }
  if (value === false) {
    return 'NO';
  }
  return undefined;
}

export function firstAddressLine(address?: { addressLines?: string[] }): string | undefined {
  return address?.addressLines?.[0];
}
